let env = 'production';		// production development staging
let whitelabel = 1234567910;
let domain = 'https://fintech.bedigital.co.id/';

if (env === 'production') {
	whitelabel = 1234567910;
	domain = 'https://apiweb.posfin.id/';
} else if (env === 'development') {
	whitelabel = 1234567900;
	domain = 'https://fintech-stg.bedigital.co.id/';
} else if (env === 'staging') {
	whitelabel = 1234567900;
	domain = 'https://apiweb2.posfin.id/';
}

const config = {
	whitelabel : whitelabel,
	language : "id",
	platform : "web",
	app_version : "1.0.0",
	user_agent : "web/1.0.0",
	env : env,
	helpdesk_email : "mypos_support@mbstelco.com",
	admin_email : "mypos_support@mbstelco.com",
	list_tarif_url : "https://www.dropbox.com/s/98ph0z2cyq2o3nt/Tarif_to_MA_20191025.pdf?dl=1",
	list_tarif_name : "List Tarif November 2019"
};

export default config;


// WEBPACK FOOTER //
// ./src/helper/config.js